import { PayloadAction } from "@reduxjs/toolkit";
import { LocationsState } from "../../models/LocationsState";
import { GetLocationPayload } from "../../payload/GetLocation/GetLocationPayload";

const getLocationFetch = (state: LocationsState, action: PayloadAction<GetLocationPayload>) => {
    state.isLoading = true;
}

export default getLocationFetch;